import React, { useEffect, useState } from 'react'
import { CButton, CCard, CCardBody, CCardTitle, CCardText, CCol, CImage } from '@coreui/react'
import { cilArrowCircleLeft } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import apiClient from '../../services/apiClient'
import { buildApiUrl } from '../../utils/getConfiguration'
import WidgetFinance from '../widgets/WidgetFinance'
import WidgetFinanceProvider from '../widgets/WidgetFinanceProvider'
import WidgetInsurance from '../widgets/WidgetInsurance'

const Finances = () => {
  const [moneyrequests, setMoneyrequests] = useState([])

  const fetchMoneyrequestsData = async () => {
    try {
      const response = await apiClient.get(
        buildApiUrl('accountFinances', {
          account_ID: localStorage.getItem('account_ID'),
          grp_ID: localStorage.getItem('grp_ID'),
        }),
      )
      setMoneyrequests(response.data)
    } catch (error) {
      console.error('Error fetching recommendations', error)
    }
  }

  useEffect(() => {
    fetchMoneyrequestsData()
  }, [])

  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CCol sm={12}>
            <h4 id="traffic" className="card-title mb-0">
              <p id="caption 2">Get Asset Insurance</p>
            </h4>
          </CCol>
          <hr></hr>
          <CCol sm={12}>
            <CButton
              color="primary"
              onClick={() => {
                //localStorage.removeItem('loginName1')
                //localStorage.removeItem('wizard')
                console.log('Back')
                window.history.back()
              }}
            >
              <CIcon icon={cilArrowCircleLeft} size="xxl" />
            </CButton>
          </CCol>
        </CCardBody>
      </CCard>
      <CCard className="mb-4">
        <CCardBody>
          <CCol>
            <h4 id="traffic" className="card-title mb-0">
              <p id="caption 2">Needed Investments</p>
            </h4>
            <p id="caption 2">Personal Loan, Home Equity Loans</p>
            <WidgetFinance parameter={'1'} />
            <h4 id="traffic" className="card-title mb-0">
              <p id="caption 2">Needed Insurance</p>
            </h4>
            <p id="caption 2">
              Life Insurance, Health Insurance, Auto Insurance, Homeowners/Renters Insurance, Pet
              Insurance
            </p>
            <WidgetInsurance parameter={'1'} />
          </CCol>
        </CCardBody>
      </CCard>
      <WidgetFinanceProvider parameter={'1'} />
      <CCard>
        <CCardBody>
          <CCol sm={12}>
            <CButton
              color="primary"
              onClick={() => {
                console.log('Back')
                window.history.back()
              }}
            >
              <CIcon icon={cilArrowCircleLeft} size="xxl" />
            </CButton>
          </CCol>
        </CCardBody>
      </CCard>
    </>
  )
}

export default Finances
